/** Carrier-first fulfillment; in-house delivery UI is hidden when true. */
export const USE_CARRIER_FULFILLMENT = true;

const LB_PER_KG = 2.20462;

export function estimateOrderWeightLbs(
  items?: Array<{ qty: number; unit: string }>,
): number {
  if (!items?.length) return 2;
  const total = items.reduce((sum, item) => {
    const u = String(item.unit || '').toUpperCase();
    const qty = Number(item.qty || 0);
    if (u === 'KG') return sum + qty * LB_PER_KG;
    if (u === 'PACK') return sum + 2;
    return sum + qty;
  }, 0);
  return Math.max(0.5, Number(total.toFixed(1)));
}

export function isInternationalDestination(country?: string | null): boolean {
  const c = String(country || '').trim().toUpperCase();
  if (!c) return false;
  return !['US', 'USA', 'UNITED STATES', 'UNITED STATES OF AMERICA'].includes(c);
}
